/**
 * Helper functions for indenting XML
 *
 */

function isTag(str: string): boolean {
    return /<[^>!]+>/.test(str);
}
function isXMLDeclaration(str: string): boolean {
    return /<\?[^?>]+\?>/.test(str);
}

function isSelfClosingTag(str: string): boolean {
    return /<[^>]+\/>/.test(str);
}

function splitOnTags(str: string): string[] {
    return str.split(/(<\/?[^>]+>)/g).filter((line) => line.trim() !== '');
}

function isClosingTag(str: string): boolean {
    return /<\/+[^>]+>/.test(str);
}

function isOpeningTag(str: string): boolean {
    return isTag(str) && !isClosingTag(str) && !isSelfClosingTag(str) && !isXMLDeclaration(str);
}

export function formatXml(xml: string): string {
    let depth = 0;
    const indent = '    ';

    return splitOnTags(xml)
        .map((item) => {
            if (isClosingTag(item)) {
                depth--;
            }

            const line = indent.repeat(depth) + item;

            if (isOpeningTag(item)) {
                depth++;
            }

            return line;
        })
        .join('\n');
}
